import {Container} from '@mui/material';

const AppContainer = ({children}) => (
  <Container component="main" maxWidth="lg" sx={{py: 6}}>
    {children}
  </Container>
);

export default AppContainer;
